import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { validateFields } from './FormValidation';
import { Prompt } from 'react-router';
import history from '../../../../..//history';
import { Link } from 'react-router-dom';
import { notificationError } from '../../../../../redux/actions/Notification/notificationActions';
import { postMacSubTypeNew, macSubTypeTriggerHighlight, getMacSubTypeDetail, putMacSubTypeUpdate } from '../../../../../redux/actions/MacSubTypes/MacSubTypeActions';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import SearchIcon from '@material-ui/icons/Search';
import AddIcon from '@material-ui/icons/Add';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import MainPage from '../../../../../components/MainPage/MainPage';
import MainPageHeader from '../../../../../components/MainPageHeader/MainPageHeader';
import MainPageBody from '../../../../../components/MainPageBody/MainPageBody';
import { getFactoryId } from '../../../../../utils/helper.js';
import dictionary from '../../../../../redux/actions/Translation/dictionary'
import './MachineSubTypeForm.scss';
import { formatDate } from '../../../../../utils/date';
class MachineSubTypeForm extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            translations: {
                ...this.convert()
            },
            translationTimestamp: undefined,
            machineSubTypeId: null,
            machineTypeId: null,
            hasFormChanges: false,
            disablePrompt: false,
            title: null,
            saveLabel: null,
            factoryId: null,
            form: {
                code: null,
                name: null,
                desc: null,
                isActive: 1
            },
            formErrors: []
        }
    }
    convert = () => {
        let { NOTIFICATIONS: { are_you_sure_to_leave_this_page, machine_sub_type_code_exists }, EDIT_MACHINE_SUBTYPE, ADD_MACHINE_SUB_TYPE,MACHINE_SUBTYPE_CODE, MACHINE_TYPE_CODE, SAVE, ADD, CANCEL, STATUS, Active, Inactive, UPDATED_BY, UPDATED_DATE, CREATED_BY, CREATED_DATE,
        BRAND_CODE,DISPLAY_NAME,COMPANY_NAME, WEBSITE,DESCRIPTION, SHORT_NAME_FOR_SYSTEM_DISPLAY
        } = dictionary.GET()
        return dictionary.TRANSLATE({
            are_you_sure_to_leave_this_page, machine_sub_type_code_exists,
            EDIT_MACHINE_SUBTYPE, ADD_MACHINE_SUB_TYPE,MACHINE_SUBTYPE_CODE, MACHINE_TYPE_CODE, SAVE, ADD, CANCEL, STATUS, Active, Inactive, UPDATED_BY, UPDATED_DATE, CREATED_BY, CREATED_DATE,
            BRAND_CODE,DISPLAY_NAME,COMPANY_NAME, WEBSITE,DESCRIPTION, SHORT_NAME_FOR_SYSTEM_DISPLAY
        })
        
    }
    handleFormChange = ({ target }) => {
        let tmpForm = this.state.form;
        tmpForm[target.name] = target.value;
        this.setState({ form: tmpForm, hasFormChanges: true });
        this.removeErrorOnChange(target.name);
    };

    handleCodeFormChange = ({ target }) => {
        let value = null;
        if (target.value.indexOf(" ") >= 0) {
            value = target.value.replace(" ", "");
        }
        else {
            value = target.value;
        }
        let tmpForm = this.state.form;
        tmpForm[target.name] = value;
        this.setState({ form: tmpForm, hasFormChanges: true });
        this.removeErrorOnChange(target.name);
    };


    handleRadioButtonChange = ({ target }) => {
        let tmpForm = this.state.form;
        tmpForm[target.name] = parseInt(target.value);
        this.setState({ form: tmpForm, hasFormChanges: true });
        this.removeErrorOnChange(target.name);
    };

    resetForm() {
        let tmpForm = {
            code: null,
            name: null,
            desc: null,
            isActive: 1
        }
        this.setState({ form: tmpForm });
    }

    checkMachineSubTypeTrigger() {
        let {translations} = this.state
        if (this.props.triggerHighlight) {
            let errors = [];
            let formValid = false;
            errors.push({ name: 'code', message: translations.machine_sub_type_code_exists });

            let tmpFormError = {
                valid: formValid,
                errors: errors
            }

            this.setState({ formErrors: tmpFormError.errors }, () => {
                this.props.macSubTypeTriggerHighlight(false);
            });
        }
    }

    componentDidMount() {
        let {translations} = this.state
        document.body.style.backgroundColor = "#F7F7FB";
        let factoryId = getFactoryId();
        if (this.props.match.params.machineSubTypeId) {
            this.props.getMacSubTypeDetail(this.props.match.params.machineSubTypeId)
            this.setState({ title: translations.EDIT_MACHINE_SUBTYPE, saveLabel: translations.SAVE, machineTypeId: this.props.match.params.machineTypeId, machineSubTypeId: this.props.match.params.machineSubTypeId, factoryId: factoryId });
        }
        else {
            this.setState({ title: translations.ADD_MACHINE_SUB_TYPE, saveLabel: translations.ADD, factoryId: factoryId, machineTypeId: this.props.match.params.machineTypeId });
        }
    }

    renderBooleanAsInteger(bool) {
        if (bool === true) {
            return 1
        }
        else {
            return 0
        }
    }

    renderText(field) {
        if (field === null || field === '') {
            return '-'
        }
        else {
            //   return field != undefined ? field.toString().translate() : field
            return field
        }
    }

    renderDate(date) {
        if (date !== null) {
            let timezone = moment.parseZone(date).format('Z');
            let dateTimeOnly = moment.parseZone(date).format('YYYY-MM-DD HH:mm:ss') + '+00:00';
            return moment(dateTimeOnly).utcOffset(timezone).format('DD-MM-YYYY');
        }
        else {
            return '-';
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.macSubTypeDetail !== null && nextProps.macSubTypeDetail !== undefined && this.props.match.params.machineSubTypeId !== null && this.props.match.params.machineSubTypeId !== undefined) {
            let tmpForm = {
                code: nextProps.macSubTypeDetail.subType,
                name: nextProps.macSubTypeDetail.desc1,
                desc: nextProps.macSubTypeDetail.desc2,
                isActive: this.renderBooleanAsInteger(nextProps.macSubTypeDetail.isActive),

            };
            this.setState({ form: tmpForm });
        }
    }

    submitForm = () => {
        let payload = {
            ...this.state.form,
            factoryId: this.state.factoryId
        };
        let formValidation = validateFields(payload);
        this.setState({ formErrors: formValidation.errors });
        if (formValidation.valid) {
            this.setState({ disablePrompt: true }, () => {
                if (this.state.machineSubTypeId === null) {
                    payload = {
                        ...payload,
                        macTypeId: this.state.machineTypeId
                    }
                    delete payload.isActive;
                    this.props.postMacSubTypeNew(payload);
                }
                else {
                    payload = {
                        ...payload,
                        macTypeId: this.state.machineTypeId
                    }
                    this.props.putMacSubTypeUpdate(this.state.machineSubTypeId, payload);
                }
            })
        }
        else {
            this.props.notificationError(formValidation.errors[0].message);
        }
    }

    removeErrorOnChange(field) {
        let errors = this.state.formErrors.filter((item) => { return item.name !== field });
        this.setState({ formErrors: errors });
    }

    hasErrors = (field) => {
        let checkField = this.state.formErrors.filter((item) => { return item.name === field });
        if (checkField.length > 0) {
            return true
        }
        else {
            return false;
        }
    }

    getErrors = (field) => {
        let checkField = this.state.formErrors.filter((item) => { return item.name === field });
        let errorString = null;
        checkField.map((item) => {
            errorString += item.message + '. ';
            return '';
        })
        return errorString;
    }

    renderStatusForm() {
        let {translations} = this.state
        return (
            <div>
                <div className="space"></div>
                <Paper className="body end">
                    <div className="form-input">
                        <FormControl className="control-row" fullWidth>
                            <Grid container spacing={0}>
                                <Grid item xs={5}>
                                    <FormLabel className="status" component="legend">{translations.STATUS}</FormLabel>
                                </Grid>
                                <Grid item xs={7}>
                                    <RadioGroup onChange={this.handleRadioButtonChange} name="isActive" className="radioButton" row value={this.state.form.isActive}>
                                        <FormControlLabel value={1} control={<Radio color="primary" />} label={translations.Active} />
                                        <FormControlLabel value={0} control={<Radio color="primary" />} label={translations.Inactive} />
                                    </RadioGroup>
                                </Grid>
                                <Grid className="statusDetails" item xs={12}>
                                    <FormLabel component="legend">{translations.UPDATED_BY}: {this.props.macSubTypeDetail ? this.renderText(this.props.macSubTypeDetail.updatedBy) : null}</FormLabel>
                                </Grid>
                                <Grid className="statusDetails" item xs={12}>
                                    <FormLabel component="legend">{translations.UPDATED_DATE}: {this.props.macSubTypeDetail ? formatDate(this.props.macSubTypeDetail.updatedDt) : null}</FormLabel>
                                </Grid>
                                <Grid className="statusDetails" item xs={12}>
                                    <FormLabel component="legend">{translations.CREATED_BY}: {this.props.macSubTypeDetail ? this.renderText(this.props.macSubTypeDetail.createdBy) : null}</FormLabel>
                                </Grid>
                                <Grid className="statusDetails" item xs={12}>
                                    <FormLabel component="legend">{translations.CREATED_DATE}: {this.props.macSubTypeDetail ? formatDate(this.props.macSubTypeDetail.createdDt) : null}</FormLabel>
                                </Grid>
                            </Grid>
                        </FormControl>
                    </div>
                </Paper>
            </div>
        )
    }

    componentDidUpdate = () => {
        let { translations } = this.state
        if (this.props.translation && this.props.translation.translations.timeStamp != this.state.translationTimestamp) {
            this.setState({
                translationTimestamp: this.props.translation.translations.timeStamp,
                translations: Object.assign({}, { ...this.convert() }),
                title: this.props.match.params.id ? this.convert().EDIT_MACHINE_SUBTYPE : this.convert().ADD_MACHINE_SUB_TYPE,
                saveLabel: this.props.match.params.id ? this.convert().SAVE : this.convert().ADD
            })
        }
        if (this.state.hasFormChanges) {
            window.onbeforeunload = () => { return translations.are_you_sure_to_leave_this_page }
        }
        else {
            window.onbeforeunload = undefined
        }
    }

componentWillUnmount(){
    document.body.style.backgroundColor = null;
    this.resetForm();
    if (this.state.hasFormChanges) {
        window.onbeforeunload = undefined
    }
}

handleLinkClick = (url) => {
    if (this.state.machineSubTypeId) {
        history.push(url);
    }
    else {
        this.setState({ disablePrompt: true }, () => {
            history.push(url);
        })
    }
}

handleCancel = () => {
    if (localStorage.getItem('redirectConfigSubType') === 'true') {
        this.handleLinkClick(this.props.match.params.machineSubTypeId ? '/configuration/machine-config/sub-types' : '/configuration/machine-config/sub-types');
    }
    else {
        this.handleLinkClick(this.props.match.params.machineSubTypeId ? '/configuration/machine-config/sub-types' : '/configuration/machine-config/machine-type')
    }
}

render() {
    let {translations} = this.state
    return (
        <MainPage footer={false} className='machine-sub-type-form'>
            <Prompt
                when={this.state.hasFormChanges && this.state.disablePrompt === false}
                message='Are you sure to leave this page?'
            />
            { this.checkMachineSubTypeTrigger()}
            <MainPageHeader title="Machine SubType" search={false} />
            <MainPageBody>
                <div className="form-container">
                    <Paper className="body">
                        <div className="title">{this.state.title}</div>
                        <div className="form-input">
                            <form autoComplete="off">
                                <FormControl className="control-row" fullWidth>
                                    <TextField disabled={this.props.match.params.machineSubTypeId ? true : false} className={this.state.form.code ? 'label-green' : null} required error={this.hasErrors('code')} value={this.state.form.code} onChange={this.handleCodeFormChange} name="code" placeholder={translations.SHORT_NAME_FOR_SYSTEM_DISPLAY} label={translations.MACHINE_SUBTYPE_CODE} InputLabelProps={{ shrink: true }} />
                                </FormControl>
                                <FormControl className="control-row" fullWidth>
                                    <TextField className={this.state.form.name ? 'label-green' : null} required error={this.hasErrors('name')} value={this.state.form.name} onChange={this.handleFormChange} name="name" placeholder="Short name for system display" label={translations.DISPLAY_NAME} InputLabelProps={{ shrink: true }} />
                                </FormControl>
                                <FormControl className="control-row" fullWidth>
                                    <TextField className={this.state.form.desc ? 'label-green' : null} error={this.hasErrors('desc')} value={this.state.form.desc} onChange={this.handleFormChange} name="desc" label={translations.DESCRIPTION} InputLabelProps={{ shrink: true }} />
                                </FormControl>
                            </form>
                        </div>
                    </Paper>
                    {this.state.machineSubTypeId ? this.renderStatusForm() : null}
                </div>
                <div className="footer-actions">
                    <Grid container spacing={1}>
                        <Grid item xs={5} />
                        <Grid item xs={1}>
                            {/* <Link to="/configuration/machine-config/machine-type"> */}
                            <Button onClick={() => this.handleCancel()} className="cancel" fullWidth variant="outlined">{translations.CANCEL}</Button>
                            {/* </Link> */}
                        </Grid>
                        <Grid item xs={1}>
                            <Button onClick={this.submitForm} className="save" fullWidth color="primary" variant="contained">{this.state.saveLabel}</Button>
                        </Grid>
                        <Grid item xs={5} />
                    </Grid>
                </div>
            </MainPageBody>
        </MainPage>
    );
}
}

const mapStateToProps = state => {
    let { translationReducer } = state

    let apiLoading = {
        macSubTypeDetailLoading: state.macSubTypeListReducer.detailLoading
    }
    let data = {
        macSubTypeDetail: state.macSubTypeListReducer.macSubTypeDetail,
        triggerHighlight: state.macSubTypeListReducer.triggerHighlight
    }

    return {
        ...apiLoading,
        ...data,
        ...translationReducer

    }
}

const mapDispatchToProps = dispatch => {
    return {
        notificationError: (message) => dispatch(notificationError(message)),
        getMacSubTypeDetail: (id) => dispatch(getMacSubTypeDetail(id)),
        macSubTypeTriggerHighlight: (flag) => dispatch(macSubTypeTriggerHighlight(flag)),
        postMacSubTypeNew: (payload) => dispatch(postMacSubTypeNew(payload)),
        putMacSubTypeUpdate: (id, payload) => dispatch(putMacSubTypeUpdate(id, payload)),
    }
}

MachineSubTypeForm = connect(mapStateToProps, mapDispatchToProps)(MachineSubTypeForm);

export default MachineSubTypeForm;
